import { render, staticRenderFns } from "./ReviewYourAnswersRQS.vue?vue&type=template&id=fd57eb90"
import script from "./ReviewYourAnswersRQS.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersRQS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports